export default "__VITE_ASSET__8ea82735__"